'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.defaultCardSpec = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Card number input used for adding a card
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * Dependent on getCardSpecs() from https://github.paypal.com/ConsumerWeb-Modules/consumerweb-card/blob/master/lib/card-config.js,
                                                                                                                                                                                                                                                                   * but you could just supply an object of specifications similar to what getCardSpecs returns.
                                                                                                                                                                                                                                                                   */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTextInput = require('react-text-input');

var _reactTextInput2 = _interopRequireDefault(_reactTextInput);

var _propValidators = require('prop-validators');

var _cardUtils = require('./card-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STYLES = {
	logoWrapper: {
		height: '100%',
		position: 'absolute',
		top: 0,
		right: 0
	},

	logo: {
		display: 'inline-block',
		marginTop: 12,
		marginRight: 2
	},

	errorMessage: {
		WebkitTransition: 'all 0.25s ease-in-out',
		MozTransition: 'all 0.25s ease-in-out',
		msTransition: 'all 0.25s ease-in-out',
		OTransition: 'all 0.25s ease-in-out',
		transition: 'all 0.25s ease-in-out'
	}
};

var CardNumber = _react2.default.createClass({
	displayName: 'CardNumber',

	propTypes: {
		cardSpecs: _propValidators.cardSpecsPropType,
		label: _react.PropTypes.string.isRequired,
		errorMessage: _react.PropTypes.string,
		handleChangeCardNumber: _react.PropTypes.func.isRequired,
		handleFocus: _react.PropTypes.func,
		handleBlur: _react.PropTypes.func
	},

	getDefaultProps: function getDefaultProps() {
		return {
			handleFocus: function handleFocus() {},
			handleBlur: function handleBlur() {}
		};
	},
	getInitialState: function getInitialState() {
		return {
			cardSpec: _cardUtils.defaultCardSpec,
			showIsRequiredError: false
		};
	},


	/**
  * Handle changing card number
  * Get the specific card spec for the card based on the card number pattern
  * Call parent's handleChangeCardNumber, so it knows what the card spec is
  * @param {String} cardNumber - the card number
  * @return {String} cardNumber - the sanitized card number
  */
	handleChangeCardNumber: function handleChangeCardNumber(cardNumber) {

		// the cardSpecs for all the cards from consumerweb-card's card-config
		// https://github.paypal.com/ConsumerWeb-Modules/consumerweb-card/blob/master/lib/card-config.js#L73
		var cardSpecs = this.props.cardSpecs;

		cardNumber = cardNumber.replace(/\D+/g, '');

		// get the specific cardSpec based on the cardNumber using the autodetect from cardSpecs
		var cardSpec = cardSpecs.autodetect && (0, _cardUtils.getSpecificCardSpec)(cardSpecs, cardNumber) || _cardUtils.defaultCardSpec;
		this.setState({ cardSpec: cardSpec });
		this.handleCheckForValue(cardNumber);
		this.props.handleChangeCardNumber(cardNumber, cardSpec);
		return cardNumber;
	},


	/**
  * Check for a cardNumber value
  * If the field is required, we should show that this field needs a value
  * @param {String} cardNumber - the card number
  */
	handleCheckForValue: function handleCheckForValue(cardNumber) {
		var cardNumberSpecs = this.state.cardSpec.fields.ccNumber;
		var isRequired = cardNumberSpecs.required;
		this.setState({ showIsRequiredError: isRequired && !cardNumber });
	},


	/**
  * Call parent's handleFocus
  * @param {String} cardNumber - the card number
  */
	handleFocus: function handleFocus(cardNumber) {
		this.props.handleFocus(cardNumber);
	},


	/**
  * Check for a cardNumber value and call parent's handleBlur
  * @param {String} cardNumber - the card number
  */
	handleBlur: function handleBlur(cardNumber) {
		this.handleCheckForValue(cardNumber);
		this.props.handleBlur(cardNumber);
	},
	render: function render() {
		var errorMessage = this.props.errorMessage;

		var cardNumberSpecs = this.state.cardSpec.fields.ccNumber;

		// the card type from config separates words with a '_',
		// but we don't want '_'s so we can use the font icons
		var cardType = this.state.cardSpec.type.replace('_', '');
		var cardLogoClassNames = !(errorMessage || this.state.showIsRequiredError) && 'icon icon-medium icon-' + cardType + '-logo';

		var errorStyles = {
			height: 0,
			padding: 0
		};
		if (errorMessage) {
			errorStyles = { height: '100%' };
		}

		return _react2.default.createElement(
			'div',
			{ className: (0, _classnames2.default)({
					'vx_has-error-with-message': errorMessage,
					'vx_has-error': !errorMessage && this.state.showIsRequiredError
				}), style: { margin: '10px 0 0', position: 'relative' } },
			_react2.default.createElement(_reactTextInput2.default, { type: 'tel',
				id: 'cardNumber',
				name: 'cardNumber',
				className: 'vx_form-control vx_form-control_complex',
				label: this.props.label,
				maxlength: cardNumberSpecs.maxlength,
				pattern: cardNumberSpecs.pattern,
				required: cardNumberSpecs.required,
				handleChange: this.handleChangeCardNumber,
				handleFocus: this.handleFocus,
				handleBlur: this.handleBlur }),
			_react2.default.createElement(
				'span',
				{ style: STYLES.logoWrapper },
				_react2.default.createElement('span', { className: cardLogoClassNames, style: STYLES.logo })
			),
			_react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)({
						'vx_form-control-message': errorMessage
					}), style: _extends({}, STYLES.errorMessage, { errorStyles: errorStyles }) },
				errorMessage
			)
		);
	}
});

exports.defaultCardSpec = _cardUtils.defaultCardSpec;
exports.default = CardNumber;


//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/react-card-number/dist/index.js
// module id = 354
// module chunks = 6